
import {
  GetAddress
} from '@/services/api/map'

import { MixPanel } from "@/mixin/mixpanel";

export const state = {
  center: { lat: -2.958881, lng: 109.5543666 },
  zoom: 5.56,
  address: [],
  infoWindow: {
    position: { lat: 0, lng: 0 },
    open: false,
    address: '',
    detail: {
      currentGeofences: [],
      licensePlate: null,
      vehicle: {
        driver1: null,
      },
      alert: {
        alertCode: 0,
        descriptionIdn: null,
      },
    },
    vehicle: null,
    type: 'fleet',

  },
  type: 'fleet',
  vehicleIds: [],
  pickedColumns: [],

  tracking: {
    param: 0,
    vehicleId: null,
  },
  modalFleetHistory: false
}

export const actions = {
  setCENTER({ commit }, payload) {
    commit('CENTERING', payload)
  },
  setZOOM({ commit }, payload) {
    commit('ZOOM', payload)
  },
  closeInfo({ commit }, payload) {
    commit('CLOSE_INFO', payload)
  },
  modalFleetHistory({ commit }, payload) {
    commit('MODAL_HISTORY', payload)
  },
  setInfoWindow({ commit }, payload) {
    commit('SET_INFOWINDOW', payload)
  },
  async requestAddress({ commit }, payload) {
    await GetAddress(payload.lat, payload.lng)
      .then((res) => {
        commit('SET_ADDRESS', res.data.display_name)
      })
    // return new Promise((resolve, reject) => {
    //   GetAddress(payload.lat, payload.lng)
    //     .then((res) => {
    //       // Commit your mutation

    //       commit('SET_ALL_ADDRESS', res.data)
    //       resolve(res)
    //     })
    //     .catch((err) => {
    //       reject(err)
    //     })
    // })
  }
}

export const mutations = {
  CENTERING(state, payload) {
    if (payload.gmp) {
      state.center.lat = parseFloat(payload.gmp.latitude)
      state.center.lng = parseFloat(payload.gmp.longitude)
      state.zoom = payload.zoom
      state.infoWindow.open = payload.open
      state.infoWindow.position.lat = parseFloat(payload.gmp.latitude)
      state.infoWindow.position.lng = parseFloat(payload.gmp.longitude)
      if (payload.open) {
        state.infoWindow.detail = payload.gmp

        if (state.tracking.vehicleId != payload.gmp.vehicleId) state.tracking.param = 0;
        state.tracking.vehicleId = payload.gmp.vehicleId

        if (payload.type === 'fleet' && state.tracking.param == 0) {
          const calculatedMotionStatus = payload.gmp.calculatedMotionStatus
          var status;
          switch (calculatedMotionStatus) {
            case "M":
              status = "Moving";
              break;
            case "I":
              status = "Idle";
              break;
            case "P":
              status = "Parking";
              break;
            case "O":
              status = "Offline";
          }
          MixPanel.methods.track('View Detail Fleet Information from Fleet List Panel Live View', { status: status })
          state.tracking.param++
        } else if (payload.type === 'notif' && state.tracking.param == 0) {
          const alert = payload.gmp.alert
          var category;
          if ([24, 23, 8].includes(alert.alertCode)) {
            category = "driverBehaviour"
          } else if ([51, 52, 53, 54, 55, 56].includes(alert.alertCode)) {
            category = "dms"
          } else if ([1, 11, 17, 18, 3, 10, 12, 7, 16, 15].includes(alert.alertCode)) {
            category = "general"
          }

          MixPanel.methods.track('View Notification Today', { category: category, type: alert.descriptionEng });
          state.tracking.param++
        }
      }
      state.infoWindow.type = payload.type
    } else {
      state.infoWindow = {
        position: { lat: 0, lng: 0 },
        open: false,
        address: '',
        detail: {
          currentGeofences: [],
          vehicle: {
            driver1: null,
          },
          alert: {
            alertCode: 0,
            descriptionIdn: null,
          },
        },
        vehicle: null,
      }

      state.infoWindow.type = payload.type

      state.center.lat = -2.958881
      state.center.lng = 109.5543666
      state.zoom = 5.56
    }

  },
  ZOOM(state, payload) {
    if (payload.isZoom) {
      state.zoom = payload.zoom
    }
    state.center.lat = payload.lat
    state.center.lng = payload.lng
  },
  CLOSE_INFO(state, payload) {
    state.infoWindow.open = payload
  },
  MODAL_HISTORY(state, payload) {
    state.modalFleetHistory = payload
  },
  SET_ADDRESS(state, payload) {
    state.infoWindow.address = payload
  },
  // SET_ALL_ADDRESS (state, payload) {
  //   state.address = payload
  // },
  TYPE_OF_MAP(state, payload) {
    state.type = payload
  },
  SET_INFOWINDOW(state, payload) {
    if (state.infoWindow.open) {
      state.infoWindow.position = { lat: payload.latitude, lng: payload.longitude }
      state.infoWindow.type = payload.type
    }
  },
  TYPE_OF_MAP_INFOWINDOW(state, payload) {
    state.infoWindow = {
      position: { lat: 0, lng: 0 },
      open: false,
      address: '',
      detail: {
        currentGeofences: [],
        licensePlate: null,
        vehicle: {
          driver1: null,
        },
        alert: {
          alertCode: 0,
          descriptionIdn: null,
        },
      },
      vehicle: null,
      type: payload,
    }
  },
  SET_VEHICLEIDS(state, payload) {
    state.vehicleIds = payload;
  },
  SET_PICKED_COLUMNS(state, payload) {
    state.pickedColumns = payload;
  },
}
